// extracted by mini-css-extract-plugin
module.exports = {"login-form":"Login_login-form__1NBYb","university-logo":"Login_university-logo__2iuqg"};